import { Components } from '@mui/material';

type ReturnType = Record<'MuiInputLabel', Components['MuiInputLabel']>;

export default function FormLabel(): ReturnType {
  return {
    MuiInputLabel: {
      styleOverrides: {
        root: ({ ownerState }) => ({
          transform: ownerState.shrink
            ? 'translate(14px, -9px) scale(0.75)'
            : 'translate(14px, 6px) scale(1)',
        }),
      },
    },
  };
}
